<template>
  <v-form ref="form" @submit.prevent="saveForm">
    <div class="form-container">
      <BaseFileUpload
        accept=".pdf"
        isOptional
        :files.sync="files"
        text="Dodaj dokumenty, które mają zostać uzupełnione po wykonanym serwisie."
        helperText="Możesz dodać max. 50 plików PDF."
        @downloadFile="$emit('downloadFile', $event)"
      />
      <v-text-field
        v-model="additionalInfo"
        label="Informacje dodatkowe"
        outlined
        hint="Wskaż dodatkowe informacje dotyczące zlecenia serwisu (np. numery wagonów)"
        persistent-hint
      />
    </div>
    <DialogSaveButton type="submit" style="padding-left: 0 !important; padding-right: 0 !important" />
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseFileUpload from '@/component/Base/file-upload/base-file-upload';
import DialogSaveButton from '@/component/Dialog/dialog-save-button';
import { SERVICE_TYPE_DICT } from '@/core/dict/service-type-dict';

export default {
  name: 'RollingStockService',
  components: {
    BaseFileUpload,
    DialogSaveButton,
  },
  props: {
    entity: Object,
    isAddMode: Boolean,
  },
  data() {
    return {
      files: [],
      additionalInfo: null,
    };
  },
  created() {
    if (!this.isAddMode && this.entity) {
      this.additionalInfo = this.entity.additionalInfo;
      this.files = this.entity.attachments.map((file) => ({ ...file, name: file.mediaObject.filePath }));
    } else if (this.isFleetServiceAdded) {
      const service = this.$store.getters['service/services'].find(
        ({ serviceType }) => serviceType === SERVICE_TYPE_DICT.FLEET_SERVICE
      );
      this.files = service.attachments;
      this.additionalInfo = service.additionalInfo;
    }
  },
  computed: {
    ...mapGetters('service', ['isFleetServiceAdded']),
  },
  methods: {
    saveForm() {
      if (this.$refs.form.validate()) {
        const payload = {
          serviceType: SERVICE_TYPE_DICT.FLEET_SERVICE,
          attachments: this.files,
          additionalInfo: this.additionalInfo,
        };
        if (this.isAddMode) {
          this.$emit('addServiceItem', payload);
        } else if (this.entity) {
          this.$emit('editExistingServiceItem', payload);
        } else if (this.isFleetServiceAdded) {
          this.$store.dispatch('service/updateService', payload);
        } else {
          this.$store.dispatch('service/addService', payload);
        }

        this.$emit('submit');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
</style>
